import * as Turbo from '@hotwired/turbo';
import {Application} from "@hotwired/stimulus";
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers';

require('form-request-submit-polyfill');
require('./bootstrap');
require('./navbar-sticky');
require('./select2');
require('./tables');
require('./datePicker');
require('./mustache');

require('./owl-carousel');
require('./product-detail');

Turbo.setProgressBarDelay(10);

const application = Application.start();
const context = require.context('./Controllers', true, /\.js$/);
application.load(definitionsFromContext(context));

import * as messajes from "./messajes";
import * as navbar from './navbar';
import * as textWithLinksComponent from'./textWithLinksComponent';

textWithLinksComponent.init();
navbar.init();

document.addEventListener('turbo:load', () => {
    messajes.initPolyglot();
    navbar.init();
    textWithLinksComponent.init();
})

// document.addEventListener('turbo:before-cache', () => {
//     document.querySelectorAll('.invalid-feedback').forEach((element) => element.remove());
//
//     window.dispatchEvent(new CustomEvent('close-all'));
// });

